"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpDefWhereRendererFactory = void 0;
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const splitTitle_1 = __importDefault(require("@opsbase/lib-general/utils/splitTitle"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importDefault(require("react"));
const OpDefWhereRendererFactory = (viewField) => (item) => {
    var _a;
    if (!item)
        return null;
    const { allLabel = lib_i18n_1.default.t('anywhere'), emptyLabel = '- - -' } = viewField;
    const byTag = item.placesSelectedByTag;
    const byParent = item.placesSelectedByParent;
    const byNormal = !byTag && !byParent;
    const prefix = byTag ? 'All places tagged with ' : byParent ? 'All places within ' : '';
    const places = byTag ? item.placeTags : ((_a = item.places) === null || _a === void 0 ? void 0 : _a.map(p => p.title)) || [];
    // ALL
    if (!!byNormal && !places.length) {
        return react_1.default.createElement(Text_1.default, null, (0, getFromStringOrFunction_1.getFromStringOrFunction)(allLabel));
    }
    // NONE
    if (places.length === 0) {
        return react_1.default.createElement(Text_1.default, null, (0, getFromStringOrFunction_1.getFromStringOrFunction)(emptyLabel));
    }
    // ONE
    if (places.length === 1) {
        return react_1.default.createElement(PlaceTitle, { prefix: prefix, value: places[0] });
    }
    // MANY
    if (places.length > 1) {
        return (react_1.default.createElement(Tooltip_1.default, { tip: react_1.default.createElement(Vertical_1.default, null, places.map((v, i) => (react_1.default.createElement(Text_1.default, { key: 'tip' + i }, v)))) },
            react_1.default.createElement(PlaceTitle, { prefix: prefix, value: places[0], count: places.length - 1 })));
    }
};
exports.OpDefWhereRendererFactory = OpDefWhereRendererFactory;
exports.default = exports.OpDefWhereRendererFactory;
function PlaceTitle({ prefix, value, count }) {
    const fullTitle = value;
    const countBit = count ? ' +' + count : '';
    if (!fullTitle)
        return null;
    const { title, preTitle } = (0, splitTitle_1.default)(fullTitle);
    if (!preTitle)
        return react_1.default.createElement(Text_1.default, null, prefix + title + countBit);
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(Text_1.default, null, prefix + title + countBit),
        react_1.default.createElement(Text_1.default, { variant: "small", color: "lightgrey" }, preTitle)));
}
